<template>
  <v-layout column>
    <v-layout row align-center class="mb-2 px-2">
      <v-flex xs3 mr-2>
        <v-menu
          v-model="startDateMenu"
          :close-on-content-click="false"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="startDate"
            label="From"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker v-model="startDate" @input="startDateMenu = false; setUp()"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs3 mr-2>
        <v-menu
          v-model="endDateMenu"
          :close-on-content-click="false"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="endDate"
            label="To"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker v-model="endDate" @input="endDateMenu = false; setUp()"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex shrink>
        <v-btn small flat @click="loadAllHistory">Load All History</v-btn>
      </v-flex>
    </v-layout>

    <v-layout row wrap class="mb-2 px-2">
      <v-checkbox
        v-for="status in statuses"
        :key="status.key"
        v-model="selectedStatuses"
        :value="status.key"
        :label="status.label"
        :color="status.color"
        hide-details
        class="mr-3 mt-0 shrink"
      ></v-checkbox>
    </v-layout>

    <v-flex v-if="apiCallPending">
      <v-progress-linear indeterminate>
      </v-progress-linear>
    </v-flex>
    <v-flex v-else>
      <v-data-table
        :headers="headers"
        :items="visibleRows"
        item-key="rowKey"
        :pagination.sync="defaultSort"
        class="elevation-1"
      >
        <template slot="items" slot-scope="{ item }">
          <tr>
            <td>
              <router-link
                v-if="item.rowType === 'cc_request'"
                :to="{ name: 'coordinatedCoverageRequestShow', params: { coordinatedCoverageRequestId: item.id } }"
              >
                {{ item.startDatetime | moment('MMMM DD YYYY, h:mma') }}
              </router-link>
              <router-link v-else :to="{ name: 'shiftDetail', params: { shiftId: item.id } }">
                {{ item.startDatetime | moment('MMMM DD YYYY, h:mma') }}
              </router-link>
            </td>
            <td>{{ item.location }}</td>
            <td>{{ item.shiftRole }}</td>
            <td>
              <template v-if="item.userId">
                <router-link :to="{ name: 'employeeDetail', params: { employeeId: item.userId } }">
                {{ item.workerName }}
                </router-link>
              </template>
              <template v-else>
              </template>
            </td>
            <td>
              <v-chip
                v-if="item.status"
                small
                :color="statusMeta(item.status).color"
                :text-color="statusMeta(item.status).textColor"
              >{{ statusMeta(item.status).label }}</v-chip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import locationShiftApi from '@/api/locationShift'
import { STATUSES, defaultSelectedKeys, statusMeta, filterRows } from './location-shift-statuses'

export default {
  props: [
    'clientBusiness'
  ],
  components: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    visibleRows () {
      return filterRows(this.rows, this.selectedStatuses)
    },
  },
  created () {
    this.setUp()
  },
  watch: {
  },
  data: function () {
    return {
      startDate: this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
      endDate: this.$moment().add(1, 'year').format('YYYY-MM-DD'),
      startDateMenu: false,
      endDateMenu: false,
      defaultSort: {
        sortBy: 'startDatetime',
        ascending: false,
        rowsPerPage: 25,
      },
      headers: [
        { text: 'Date', value: 'startDatetime' },
        { text: 'Location', value: 'location' },
        { text: 'Role', value: 'shiftRole' },
        { text: 'Assigned Employee', value: 'workerName' },
        { text: 'Status', value: 'statusLabel' },
      ],
      apiCallPending: false,
      rows: [],
      statuses: STATUSES,
      selectedStatuses: defaultSelectedKeys(),
    }
  },
  methods: {
    statusMeta,
    loadAllHistory () {
      this.startDate = this.$moment().subtract(10, 'years').format('YYYY-MM-DD')
      this.endDate = this.$moment().add(1, 'year').format('YYYY-MM-DD')
      this.setUp()
    },
    setUp () {
      this.apiCallPending = true
      locationShiftApi.getList({
        client_business_id: this.clientBusiness.id,
        startDate: this.startDate,
        endDate: this.endDate,
      })
      .then(data => {
        // statusLabel lets the Status column sort by label.
        // rowKey: a CC request and a shift can share an id.
        this.rows = data.rows.map(row => ({
          ...row,
          rowKey: `${row.rowType}-${row.id}`,
          statusLabel: row.status ? statusMeta(row.status).label : '',
        }))
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.apiCallPending = false
      })
    },
  },
}
</script>

<style scoped>
</style>
